import { Component, HostListener, OnInit, OnDestroy } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';
import {ScriptsService} from '../../services/scripts.service';
import {AuthService} from '../../services/auth.service';
  import { GoogleAnalyticsService } from '../../../@core/utils/analytics.service';

declare let Wayforpay: any

@Component({
  selector: 'app-payment-modal',
  templateUrl: './payment-modal.component.html',
  styleUrls: ['./payment-modal.component.scss']
})
export class PaymentModalComponent implements OnInit, OnDestroy{


	loading:boolean = true
	formHidden:boolean = false
        wayforpay:any
	dataLoader$:any = null
        price:number = 0
	constructor(protected ref: NbDialogRef<PaymentModalComponent>,  public gAnalytics: GoogleAnalyticsService, private authService: AuthService,private scriptsService : ScriptsService  ){}



	ngOnInit(){
	 this.scriptsService.loadScript('wayForPayWidget').then((r:any)=>{

		if(r.loaded){
			this.loading = false
			this.wayforpay = new Wayforpay()
			//this.pay()
		} else {

		  
		  this.closeMainModal()

		}


	 })
        }

	
	@HostListener('window:message') onMessage() {
 
              let e : any = event
		if(e.data === 'WfpWidgetEventLoaded'){
			this.loading = false
			this.formHidden = true

		}
		
		if(e.data === 'WfpWidgetEventFadeInOverlay'){
			
			//this.formHidden = 
		}

		if(e.data === 'WfpWidgetEventClose'){

			if(!this.loading){
				this.closeMainModal()
			}

		}

	}

        pay(){


	if(this.price < 1){
		return
	}
	this.loading = true
        this.formHidden = true


			

	if(this.dataLoader$){this.dataLoader$.unsubscribe(); this.dataLoader$ = null}

	 this.dataLoader$ = this.authService.getPaymentData(this.price).subscribe((data)=>{

		this.loading = false
		     this.wayforpay.run({ 

				...data,  straightWidget: true  	
			}, ()=>{     this.gAnalytics.trackEvent('Payok')    }, ()=>{}, ()=>{}); 	

		

		},()=>{this.loading = false; this.formHidden = true})		



	}



	closeMainModal(){
		this.ref.close()

	}






	ngOnDestroy(){
		if(this.dataLoader$){this.dataLoader$.unsubscribe(); this.dataLoader$ = null}
		this.scriptsService.unloadScript('wayForPayWidget')
	}


	
}
